export default "__VITE_ASSET__CfjeAAxt__"